import React, { useState } from "react";
import { Link } from 'react-router-dom';
import api from "../services/api";
import "../styles/login.css"; // если есть отдельный CSS для логина

const Login = () => {
  // Состояния для полей ввода
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await api.login(username, password);
      // Предполагаем, что ответ содержит поле access_token
      localStorage.setItem("access_token", data.access_token);
      // Перенаправляем на главную страницу (например, /dashboard)
      window.location.href = "/orders/new"; // или используем useNavigate
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h2>Вход в CRM Олега</h2>
      {error && <div className="error">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="username">Имя пользователя</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Пароль</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? "Вход..." : "Войти"}
        </button>
        <p style={{ marginTop: "1rem", textAlign: "center" }}>
          Нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
        </p>
      </form>
    </div>
  );
};

export default Login;
